<template>
    <div class="md:container md:container-main bg-white flex">
        <!-- Nav -->

        <nav
            v-if="!isInFrame()"
            class="w-full relative cursor-pointer group z-10 xl:flex hidden"
        >
            <ul class="flex items-center h-full w-full xl:gap-6 xl:justify-start justify-between mr-3 xl:mr-0">
                <!-- <li
          v-for="link of headerKidsNav"
          :key="link.name"
          class="border-background last:border-none hover:text-primary"
        >
          <span class="text--md font-bold">{{ $t(link.name) }}</span>
        </li> -->
                <!-- <router-link
          :to="{
            name: '/products/abstractProductCode',
            params: {
              abstractProductCode:
                category.abstractProducts[0].abstractProductCode,
            },
          }"
          class="border-background last:border-none hover:text-primary"
        >
          <span class="text--md font-bold">{{ $t("common.special") }}</span>
        </router-link>
         -->
                <!-- <li class="border-background last:border-none hover:text-secondary">
          <router-link
            class="text--md font-bold"
            :class="{
              'text-secondary-pressed': $route.name === '/how-it-works',
            }"
            :to="{
              name: '/how-it-works',
            }"
          >
            {{ $t("how-it-works-page.title") }}
          </router-link>
        </li> -->
                <li class="border-background last:border-none hover:text-secondary">
                    <router-link
                        class="text--md font-bold"
                        :class="{
                            'text-secondary-pressed': $route.name === '/programs',
                        }"
                        :to="{
                            name: '/programs',
                        }"
                    >
                        {{ $t("common.workshops") }}
                    </router-link>
                </li>

                <li class="border-background last:border-none hover:text-secondary">
                    <router-link
                        class="text--md font-bold"
                        :class="{
                            'text-secondary-pressed': $route.name === '/investment-deck',
                        }"
                        :to="{
                            name: '/investment-deck',
                        }"
                    >
                        {{ $t("common.investment-deck") }}
                    </router-link>
                </li>

                <li class="border-background last:border-none hover:text-secondary">
                    <router-link
                        class="text--md font-bold"
                        :class="{
                            'text-secondary-pressed': $route.name === '/franchising',
                        }"
                        :to="{
                            name: '/franchising',
                        }"
                    >
                        {{ $t("common.franchising") }}
                    </router-link>
                </li>

                <li class="border-background last:border-none hover:text-secondary">
                    <router-link
                        class="text--md font-bold"
                        :class="{
                            'text-secondary-pressed': $route.name === '/about',
                        }"
                        :to="{
                            name: '/about',
                        }"
                    >
                        {{ $t("common.about-us") }}
                    </router-link>
                </li>

                <li class="border-background last:border-none hover:text-secondary">
                    <router-link
                        class="text--md font-bold"
                        :class="{
                            'text-secondary-pressed': $route.name === '/contacts',
                        }"
                        :to="{
                            name: '/contacts',
                        }"
                    >
                        {{ $t("common.contact-us") }}
                    </router-link>
                </li>
            </ul>
        </nav>

        <!-- Promo -->
        <div class="flex items-center gap-2 xl:gap-6 ml-[auto]">
            <!-- <router-link
        class="btn--outline--secondary z-20 py-[14px] px-6 nav-contacts"
        :to="{ name: '/contacts' }"
      >
        <div class="flex items-center gap-[12px] text-center">
          <span>{{ $t("footer.nav.contact-us") }}</span>
          <icon-link-arrow class="w-[35px] h-[24px]" />
        </div>
      </router-link>

      > -->

            <HeaderCart />

            <HeaderProfileList v-if="!isInFrame()" />
            <!--      <div>-->
            <!--        <LocalesSwitcher list-position="left" />-->
            <!--      </div>-->
        </div>
    </div>
</template>

<script setup>
// import LocalesSwitcher from "@/components/LocalesSwitcher.vue";
    import {isInFrame} from '@academy/utils';

    import HeaderCart from '@/components/header/header-nav/HeaderCart.vue';
    import HeaderProfileList from '@/components/header/header-nav/HeaderProfilesList.vue';

    defineEmits({
        'open-partner-form': null,
    });
</script>

<style lang="scss" scoped>
.nav-contacts {
  @media (max-width: 1024px) {
    display: none;
  }
}

.active {
  @apply text-secondary-pressed;
}
</style>
